export const getAll = state => {
  return state.all;
};

export const getOptions = state => {
  let options = getAll(state).map(item => {
    return {
      name: item.name,
      type: item.type,
      _refId: item._id,
      _refType: "Achievements"
    };
  });
  return options;
};

export const canEdit = rootGetters => {
  return rootGetters.isAdmin;
};
